module.exports = "<div class=\"modal-body\" style=\"font-size:18px\">\n  <div>Do you really want to delete this Patient?</div>\n</div>\n\n<div class=\"modal-footer\">\n  <button\n    class=\"btn btn-danger pull-right\"\n    ng-click=\"$uibModalInstance.close()\"\n    style=\"margin-left: 10px\"\n  >\n    Yes\n  </button>\n  <button\n    class=\"btn btn-default pull-right\"\n    ng-click=\"$uibModalInstance.dismiss()\"\n  >\n    No\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/incident/patient/patientDetails/deletePatient.html
// module id = 120
// module chunks = 0